module.exports = __webpack_public_path__ + "img/Desktop - 13.276f108c.svg";